import BirthPlaceForm from "./BirthPlaceForm";

export default BirthPlaceForm;
